import { v4 as uuidv4 } from 'uuid';

class Command {

    constructor({ id, sourceUserID, target, time, type }) {
        this.id = id ? id : uuidv4();
        Object.assign(this, { sourceUserID, target });
        this.type = type ? type : "Command";
        this.time = time ? time : Date.now();
        this.completed = false;
    }

    getType() { return this.type; }

    setID(id) { this.id = id; return this; }
    getID() { return this.id; }

    setSourceUserID(id) { this.sourceUserID = id; return this; }
    getSourceUserID() { return this.sourceUserID; }

    setTarget(id) { this.target = id; return this; }
    getTarget() { return this.target; }

    setTime(time) { this.time = time; return this; }
    getTime() { return this.time; }

    isOfType(type) {
        return type === this.type;
    }

    setCompleted() { this.completed = true; return this; }
    isCompleted() { return this.completed; }

    parseFromJSON(json) {
        if (json && json.id) {
            this
                .setID(json.id)
                .setSourceUserID(json.sourceUserID)
                .setTarget(json.target)
                .setTime(json.time)
        } else {
            console.error("Trying to parse unknown command type");
        }
        return this;
    }
}

class DeleteMessage extends Command {
    constructor({ id, sourceUserID, time, message} = {}) {
        super({ id, sourceUserID, time, type: "DeleteMessage" });
        Object.assign(this, {message});
    }

    isOfType(type) {
        return type === this.type || super.isOfType(type);
    }

    setMessage(message) { this.message = message; return this; }
    getMessage() { return this.message; }

    parseFromJSON(json) {
        if (json && json.id) {
            super.parseFromJSON(json)
                .setMessage(json.message)
        } else {
            console.error("Trying to parse unknown command type");
        }
        return this;
    }

    createFromJSON( json ) {
        return new DeleteMessage().parseFromJSON( json );
    }
}

class CommandBuilder {
    constructor() {
        this.supportedCommandTypes = new Map();
    }

    registerCommandType( command ) {
        if( command.getType ) {
            this.supportedCommandTypes.set( command.getType(), command );
        }
    }

    createFromJSON( json ) {
        if( json && json.type ) {
            //console.log("Trying to instantiate a command for type " + json.type);
            if( this.supportedCommandTypes.has( json.type ) )        
                return this.supportedCommandTypes.get( json.type ).createFromJSON( json );
            else
                console.log("Unknown command type " + json.type );
        } else {
            // Unknown datatype...
            console.error("Trying to parse unknown command type ");
        }
    }
}

const CommandBuilderInstance = new CommandBuilder();
Object.freeze(CommandBuilderInstance);

CommandBuilderInstance.registerCommandType(new DeleteMessage());

export { Command, CommandBuilder, CommandBuilderInstance, DeleteMessage }
